import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import { Tooltip } from 'dibs-elements/exports/Tooltip';

// Helpers
import actions from '../../actions/FavoritesActions';
import SanitizeHtml from '../../../utils/SanitizeHtml';
import { followingTypes, copy } from '../../constants';
import { getDisplayKey, getDisplayValue, isInternal } from './parametersHelpers';

// Styles
import style from './styles/followingHeader.scss';

class FollowingPageHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showTooltip: false,
            showModal: false,
        };

        this.removeFollowing = this.removeFollowing.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.closeTooltip = this.closeTooltip.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.closeTooltip);
        window.addEventListener('click', this.closeTooltip);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.closeTooltip);
        window.removeEventListener('click', this.closeTooltip);
    }

    removeFollowing(item) {
        this.props.selectItems([
            {
                query: item.query,
                page: item.page,
                type: item.type,
                itemId: item.serviceId,
            },
        ]);
        this.props.removeFollowing();
    }

    closeTooltip() {
        if (this.state.showTooltip) {
            this.setState({
                showTooltip: false,
            });
        }
    }

    toggleTooltip(event) {
        event.stopPropagation();

        this.setState({
            showTooltip: !this.state.showTooltip,
        });
    }

    getTooltipContents(searchParams) {
        return searchParams.map((param, index) => {
            const displayKey = getDisplayKey(param, this.props.parameters);
            const displayValue = getDisplayValue(param, this.props.parameters);

            return (
                <div data-tn={param.values} key={`${param.key}-${index}`}>
                    <SanitizeHtml content={`${displayKey}: `} />
                    <SanitizeHtml content={displayValue} />
                </div>
            );
        });
    }

    getFilter(searchParams) {
        const nonInternalParams = searchParams.filter(param => !isInternal(param.key));

        if (nonInternalParams.length) {
            return (
                <a className={style.filter} onClick={this.toggleTooltip} data-tn="show-filters">
                    {copy.following.FILTER_APPLIED}
                    <Tooltip
                        isVisible={this.state.showTooltip}
                        direction="bottom"
                        align="right"
                        containerClass={style.tooltipContainer}
                    >
                        {this.getTooltipContents(nonInternalParams)}
                    </Tooltip>
                </a>
            );
        }
        return null;
    }

    getLocation(dealerParams) {
        return dealerParams.map((param, index) => (
            <span key={index} className={style.headerItem}>
                {param.values}
            </span>
        ));
    }

    getNewItems(newItems) {
        if (newItems && newItems.values[0] !== '0') {
            return (
                <span className={style.newItemsWrapper}>
                    <span className={style.newItems}>{newItems.values[0] + ' NEW'}</span>
                </span>
            );
        }
        return null;
    }

    render() {
        const { item, name, type, page, parameters, pageLink } = this.props;
        // Filter out parameters we do not want to be dispalyed for search.
        const searchParams = parameters.filter(
            param => ['query', 'currency', 'new_item_count'].indexOf(param.key) === -1
        );
        // Only show location parameter for dealers.
        const dealerParams = parameters.filter(param => param.key === 'location');
        const newItems = parameters.filter(param => param.key === 'new_item_count').pop();
        let pageLinkEl;

        if (pageLink) {
            pageLinkEl = (
                <a href={page} className={style.favoriteName} data-tn="favorite-item-name-link">
                    {name}
                </a>
            );
        } else {
            pageLinkEl = (
                <span className={style.unavailable} data-tn="favorite-item-name-link">
                    {name}
                </span>
            );
        }

        return (
            <div className={style.header} data-tn="favorite-item-header">
                <a
                    className={style.remove}
                    onClick={() => this.removeFollowing(item)}
                    data-tn="favorite-item-view-more-link"
                >
                    {copy.following.REMOVE}
                </a>
                {pageLinkEl}
                {type === followingTypes.SEARCH
                    ? this.getFilter(searchParams)
                    : this.getLocation(dealerParams)}
                {this.getNewItems(newItems)}
            </div>
        );
    }
}

FollowingPageHeader.propTypes = {
    item: PropTypes.object,
    name: PropTypes.string,
    removeFollowing: PropTypes.func,
    type: PropTypes.string,
    parameters: PropTypes.array,
    page: PropTypes.string,
    pageLink: PropTypes.bool,
    selectItems: PropTypes.func,
};

const mapDispatchToProps = dispatch => {
    return {
        selectItems: selectedItems => {
            dispatch(actions.selectItems({ selectedItems }));
        },
    };
};

export default connect(
    null,
    mapDispatchToProps
)(FollowingPageHeader);
